export class FiltersModel {
  valueType: any = null;
  dateType = 'CreatedDate';
  nameType = 'ContainerNo';
}
